import { ToggleButton } from '@populix/pop-ui'
import Image from 'next/image'

import { PulseLoading } from '..'

import bankList from '@/libs/constants/bank-list'
import { TPayoutInfo } from '@/libs/types/global.types'

type TProfileSection = {
  readonly label: string
  readonly value?: TPayoutInfo
  readonly isLoading: boolean
  readonly disableOnChange?: boolean
  readonly onChange?: () => void
  readonly onToggleChange?: (state: boolean) => void
  readonly actionType?: 'button' | 'toggle'
  readonly toggleState?: boolean
}

export default function ProfilePayoutSection({
  label,
  value,
  isLoading,
  disableOnChange,
  onChange,
  actionType = 'button',
  onToggleChange,
  toggleState = false,
}: TProfileSection) {
  if (isLoading) {
    return <PulseLoading />
  }

  return (
    <div className='flex flex-col gap-4'>
      <h3 className='text-xs font-semibold'>{label}</h3>
      <div className='flex flex-row justify-between'>
        {value ? (
          <div className='sentry-mask flex flex-row items-center gap-3'>
            {value.type === 'BANK' && (
              <Image
                src={bankList?.[value?.provider]?.src ?? bankList.unknown.src}
                width={70}
                height={50}
                alt={bankList?.[value?.provider]?.alt ?? bankList.unknown.src}
                className='h-6 w-8'
                data-testid='bank-image'
              />
            )}
            <p className='text-xs font-normal text-pop-grey-500'>{value?.accountNumber}</p>
          </div>
        ) : (
          <p className='text-xs font-normal text-pop-grey-500'>-</p>
        )}
        {!disableOnChange && actionType === 'button' && (
          <button
            className='cursor-pointer text-right text-xs font-normal text-pop-blue-400'
            onClick={onChange}
            type='button'
          >
            {value ? 'Change' : 'Add'}
          </button>
        )}

        {!disableOnChange && actionType === 'toggle' && onToggleChange && (
          <ToggleButton onToggleButton={onToggleChange} state={toggleState} />
        )}
      </div>
    </div>
  )
}
